<template>
    <div class="search-results__container" :ref="'used-results'">
        <notifications></notifications>
        <login-modal v-if="loginModal.show == true"></login-modal>
        <saved-vehicle-modal v-else-if="showSavedVehicleModal == 1" ></saved-vehicle-modal>

        <used-search-results-filters class="search-results__filters" :class="{'search-results__filters--visible': refineSearchVisible}" ref="filters" v-on:close-filters="toggleShowingFilters" v-on:scroll-to-results="scrollToResults" />
        <div class="search-results__right-side" ref="results">
            <h1 class="search-results__h1" v-if="haveResults && seoH1" v-html="seoH1"></h1>

            <div class="search-results__xs-filter-btns">
                <button class="btn btn--blue-inverted btn--normal-case btn--center-contents" @click="toggleShowingFilters">Refine Search <img src="/images/used/refine-search.svg" alt="Refine Search Icon" style="margin-left: 5px" /></button>
            </div>

            <div v-if="haveResults && seoTextTopOfPage" class="search-results__seo-content hidden__xs hidden__sm" v-html="seoTextTopOfPage"></div>

            <div class="search-results__sort-by-row">
                <div class="search-results__count">{{ resultCountString }}</div>
                <div class="search-results__sort-by">
                    <label for="searchResultsSortBy" class="search-results__sort-by-label">Sort by</label>
                    <select class="form-element__input search-results__sort-by-input" id="searchResultsSortBy" v-model="sortBy">
                        <option v-for="option in sortByOptions" :value="option.value" :key="option.value">{{ option.label }}</option>
                    </select>
                </div>
            </div>
            <div class="search-results__results-container" v-if="resultsLoading == false && haveResults">
                <template v-for="vehicle in results">
                    <fake-card :key="vehicle.id" v-if="vehicle.fake_card"></fake-card>
                    <used-vehicle-result v-else :key="vehicle.id" :vehicle="vehicle" v-on:card-updated="handleMatchHeight"></used-vehicle-result>
                </template>
            </div>
            <div class="search-results__results-container" v-else-if="resultsLoading !== false">
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
                <used-vehicle-result-loader></used-vehicle-result-loader>
            </div>

            <div v-if="!resultsLoading && !haveResults">
                <h2 class="search-results__no-results">Sorry, we found no vehicles matching your search</h2>
                <div class="search-results__car-alert-bg">
                    <div class="search-results__car-alert-container">
                        <div class="search-results__car-alert-icon-and-h3">
                            <svg class="search-results__car-alert-icon" width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M18.4371 8.98478C15.9297 7.53714 12.7083 8.40716 11.255 10.9243L9.91897 13.2383C8.75899 15.2475 6.78656 16.6384 4.50913 17.0532C4.46583 17.0614 4.39052 17.0866 4.34262 17.1696C4.27752 17.2823 4.31716 17.4315 4.42962 17.4964L8.7696 20.0021L13.7296 22.8657L18.0696 25.3714C18.1819 25.4362 18.3308 25.396 18.3959 25.2833C18.4438 25.2003 18.4282 25.1226 18.4142 25.0835C17.6339 22.9012 17.8523 20.4975 19.0123 18.4884L20.3483 16.1744C21.8016 13.6572 20.9443 10.4323 18.4371 8.98478ZM19.614 5.51454L18.5167 7.41502C15.4364 6.05195 11.7431 7.21521 10.015 10.2084L8.67898 12.5224C7.7307 14.1649 6.11897 15.3013 4.24597 15.6419C3.76472 15.7326 3.34803 16.0286 3.10262 16.4537C2.64025 17.2545 2.91302 18.2807 3.71087 18.7413L7.49312 20.925C6.96181 22.5102 7.59608 24.3042 9.09334 25.1686C10.5906 26.0331 12.4613 25.6854 13.5686 24.4326L17.3508 26.6163C18.1485 27.0769 19.1736 26.8 19.6359 25.9992C19.8813 25.5741 19.9293 25.0653 19.7624 24.5926C19.1257 22.8108 19.304 20.8467 20.2523 19.2043L21.5883 16.8903C23.3164 13.8971 22.4772 10.117 19.7567 8.13093L20.854 6.23045C21.0523 5.88686 20.9356 5.44764 20.5933 5.25004C20.2511 5.05245 19.8123 5.17095 19.614 5.51454ZM23.9155 19.0639C23.5733 18.8663 23.4565 18.427 23.6549 18.0834C25.0311 15.6999 25.4002 12.9263 24.6952 10.2718C24.5934 9.88884 24.821 9.49464 25.2036 9.39132C25.5862 9.288 25.9788 9.51469 26.0808 9.89775C26.8841 12.9221 26.4627 16.0839 24.8949 18.7994C24.6965 19.143 24.2578 19.2615 23.9155 19.0639ZM6.96898 9.27977C6.62675 9.08218 6.50999 8.64296 6.70836 8.29936C8.27615 5.58387 10.8038 3.63813 13.8249 2.82286C14.2075 2.71954 14.6003 2.94632 14.7021 3.32929C14.8039 3.71226 14.5762 4.10662 14.1937 4.20994C11.542 4.92529 9.32453 6.63167 7.94836 9.01527C7.74998 9.35887 7.31122 9.47736 6.96898 9.27977ZM9.81209 23.9237C10.6206 24.3905 11.6104 24.2684 12.2847 23.6914L8.777 21.6662C8.61436 22.5386 9.00344 23.4568 9.81209 23.9237Z"
                                    fill="#031332"
                                />
                            </svg>
                            <h3 class="search-results__car-alert-h3">Create a stock alert</h3>
                        </div>
                        <p class="search-results__car-alert-copy">Unfortunately we have no stock that matches your criteria at the moment.<br />Would you like to save this search and we can alert you when stock comes in?</p>
                        <button class="btn btn--primary search-results__car-alert-btn" @click="createCarAlert">Create Stock Alert</button>
                    </div>
                </div>
            </div>


            <template v-if="haveResults">
                <used-results-paging></used-results-paging>

                <div class="search-results__car-alert-bg search-results__car-alert-bg--m-t">
                    <div class="search-results__car-alert-container">
                        <div class="search-results__car-alert-icon-and-h3">
                            <svg class="search-results__car-alert-icon" width="30" height="31" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M18.4371 8.98478C15.9297 7.53714 12.7083 8.40716 11.255 10.9243L9.91897 13.2383C8.75899 15.2475 6.78656 16.6384 4.50913 17.0532C4.46583 17.0614 4.39052 17.0866 4.34262 17.1696C4.27752 17.2823 4.31716 17.4315 4.42962 17.4964L8.7696 20.0021L13.7296 22.8657L18.0696 25.3714C18.1819 25.4362 18.3308 25.396 18.3959 25.2833C18.4438 25.2003 18.4282 25.1226 18.4142 25.0835C17.6339 22.9012 17.8523 20.4975 19.0123 18.4884L20.3483 16.1744C21.8016 13.6572 20.9443 10.4323 18.4371 8.98478ZM19.614 5.51454L18.5167 7.41502C15.4364 6.05195 11.7431 7.21521 10.015 10.2084L8.67898 12.5224C7.7307 14.1649 6.11897 15.3013 4.24597 15.6419C3.76472 15.7326 3.34803 16.0286 3.10262 16.4537C2.64025 17.2545 2.91302 18.2807 3.71087 18.7413L7.49312 20.925C6.96181 22.5102 7.59608 24.3042 9.09334 25.1686C10.5906 26.0331 12.4613 25.6854 13.5686 24.4326L17.3508 26.6163C18.1485 27.0769 19.1736 26.8 19.6359 25.9992C19.8813 25.5741 19.9293 25.0653 19.7624 24.5926C19.1257 22.8108 19.304 20.8467 20.2523 19.2043L21.5883 16.8903C23.3164 13.8971 22.4772 10.117 19.7567 8.13093L20.854 6.23045C21.0523 5.88686 20.9356 5.44764 20.5933 5.25004C20.2511 5.05245 19.8123 5.17095 19.614 5.51454ZM23.9155 19.0639C23.5733 18.8663 23.4565 18.427 23.6549 18.0834C25.0311 15.6999 25.4002 12.9263 24.6952 10.2718C24.5934 9.88884 24.821 9.49464 25.2036 9.39132C25.5862 9.288 25.9788 9.51469 26.0808 9.89775C26.8841 12.9221 26.4627 16.0839 24.8949 18.7994C24.6965 19.143 24.2578 19.2615 23.9155 19.0639ZM6.96898 9.27977C6.62675 9.08218 6.50999 8.64296 6.70836 8.29936C8.27615 5.58387 10.8038 3.63813 13.8249 2.82286C14.2075 2.71954 14.6003 2.94632 14.7021 3.32929C14.8039 3.71226 14.5762 4.10662 14.1937 4.20994C11.542 4.92529 9.32453 6.63167 7.94836 9.01527C7.74998 9.35887 7.31122 9.47736 6.96898 9.27977ZM9.81209 23.9237C10.6206 24.3905 11.6104 24.2684 12.2847 23.6914L8.777 21.6662C8.61436 22.5386 9.00344 23.4568 9.81209 23.9237Z"
                                    fill="#031332"
                                />
                            </svg>
                            <h3 class="search-results__car-alert-h3">Create a stock alert</h3>
                        </div>
                        <p class="search-results__car-alert-copy">Can't find the car you're looking for?<br />You can save this search and we will alert you when stock comes in</p>
                        <button class="btn btn--primary search-results__car-alert-btn" @click="createCarAlert">Create Stock Alert</button>
                    </div>
                </div>

                <fixed-representative-example></fixed-representative-example>

                <div v-if="seoTextBottomOfPage" class="search-results__seo-content hidden-xs" v-html="seoTextBottomOfPage" id="more-info"></div>

                <p class="terms" id="bottom-terms">
                    *<template v-if="personalQuote">This is your personal quote, we will retain your deposit as you move around the website. </template>Quotes are valid for a maximum of 14 days from {{ date }} and may be withdrawn without
                    notice. Finance subject to status and age limitations. We may introduce you to a carefully selected group of finance providers. Stellantis &You UK Limited, trading as Stellantis &You Sales & Services, is acting as a credit broker
                    and not a lender and will introduce you to a limited number of lenders. <a href="/terms-and-conditions">Ts and Cs apply</a>.
                </p>
                <p class="terms">
                    ^£500 Deposit Contribution only available when vehicle purchased on Personal Contract Purchase or Conditional Sale through Stellantis Financial Services UK Limited. Not available to cash customers. Customer must be a UK resident and 18+. Northern Ireland, Channel Islands and Isle of Man excluded.
                </p>
            </template>
        </div>

        <SiteLinks v-if="brand" :brand="brand" :show-new="false" />
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CreateCarAlert from "../api/car-alert/CreateCarAlert";
import UsedSearchResultsFilters from "../components/UsedSearchResultsFilters.vue";
import LoginModal from "../components/LoginModal.vue";
import UsedVehicleResultLoader from "../components/ContentLoaders/UsedVehicleResult.vue";
import UsedResultsPaging from "../components/UsedResultsPaging.vue";
import UsedVehicleResult from "../components/UsedVehicleResult.vue";
import FixedRepresentativeExample from "../components/Finance/FixedRepresentativeExample.vue";
import Notifications from "../components/Notifications.vue";
import SiteLinks from "../components/Layout/SiteLinks.vue";
import FakeCard from "../components/Campaign/2025/October/FakeCard.vue";
import NumberFormat from '../api/NumberFormat';
import { MatchHeight } from 'js-match-height';
import { debounce } from "lodash";

const bodyScrollLock = require('body-scroll-lock');
const VueScrollTo = require("vue-scrollto");
Vue.use(VueScrollTo);

export default {
    components: {
        UsedSearchResultsFilters,
        UsedVehicleResult,
        UsedVehicleResultLoader,
        UsedResultsPaging,
        FixedRepresentativeExample,
        Notifications,
        SiteLinks,
        FakeCard,
        LoginModal
    },
    data() {
        return {
            showFilters: false
        };
    },
    computed: {
        ...mapGetters({
            count: "UsedSearchOptions/count",
            sortBys: 'UsedSearchOptions/sortBys',
            loginModal: 'Auth/loginModal',
        }),

        ...mapState("UsedSearchOptions", ["pages", "haveResults", "results", "resultsLoading", "userOptions", "usedVehicleModelLandingPageData", "dealerLandingPage", "notifications", 'refineSearchVisible']),
        ...mapState("Layout", [
            'showSavedVehicleModal',
        ]),
        ...mapState("FinanceParameters", {
            personalQuote: "modified",
        }),

        sortByOptions() {
            let options = [];
            for (let index = 0, len = this.sortBys.length; index < len; index++) {
                // If it's the distance sort and we don't have a distance set, don't include it
                if (this.sortBys[index].value == 'dist' && !this.$store.state.Dealers.haveLocation) {
                    continue;
                }
                options.push(this.sortBys[index]);
            }
            return options;
        },

        sortBy: {
            get() {
                return this.$store.state.UsedSearchOptions.userOptions.sortBy;
            },
            set (value) {
                this.gaTag('Used Vehicles - Results', 'Clicked', 'Sort By - ' + value);
                this.$store.dispatch('UsedSearchOptions/setUserOptionsByPushingRoute', {
                    sortBy: value,
                });
            }
        },

        paymentSearch() {
            return this.$store.state.UsedSearchOptions.userOptions.paymentSearch;
        },

        brand() {
            if (this.$route.params && this.$route.params.brand) {
                return this.$route.params.brand;
            }
            return false;
        },
        date() {
            const date = new Date();
            return date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
        },

        resultCountString() {
            if (typeof this.pages.current_page == "undefined") {
                return '';
            }
            const start = (this.pages.current_page - 1) * this.pages.per_page + 1;
            return start + ' - '  + (start + this.pages.per_page - 1) + ' of ' + NumberFormat(this.count);
        },

        currentPage() {
            if (typeof this.pages.current_page == "undefined") {
                return 0;
            }
            return this.pages.current_page;
        },

        specialOfferPage() {
            return this.userOptions.specialOffer == "1" || this.userOptions.specialOffer == 1 ? true : false;
        },

        seoH1() {
            if (this.usedVehicleModelLandingPageData && this.currentPage == 1 && this.usedVehicleModelLandingPageData.h1 !== null && this.usedVehicleModelLandingPageData.h1 !== "") {
                return this.usedVehicleModelLandingPageData.h1;
            }
            if (this.dealerLandingPage && this.currentPage == 1 && this.dealerLandingPage.landing_page_h1 !== null && this.dealerLandingPage.landing_page_h1 !== "") {
                return this.dealerLandingPage.landing_page_h1;
            }
            return false;
        },

        seoTextTopOfPage() {
            if (this.usedVehicleModelLandingPageData && this.currentPage == 1 && this.usedVehicleModelLandingPageData.top_text !== null && this.usedVehicleModelLandingPageData.top_text !== "") {
                return this.usedVehicleModelLandingPageData.top_text;
            }
            if (this.dealerLandingPage && this.currentPage == 1 && this.dealerLandingPage.landing_page_top_text !== null && this.dealerLandingPage.landing_page_top_text !== "") {
                return this.dealerLandingPage.landing_page_top_text;
            }
            return false;
        },

        seoTextBottomOfPage() {
            if (this.usedVehicleModelLandingPageData && this.currentPage == 1 && this.usedVehicleModelLandingPageData.bottom_text !== null && this.usedVehicleModelLandingPageData.bottom_text !== "") {
                return this.usedVehicleModelLandingPageData.bottom_text;
            }
            if (this.dealerLandingPage && this.currentPage == 1 && this.dealerLandingPage.landing_page_bottom_text !== null && this.dealerLandingPage.landing_page_bottom_text !== "") {
                return this.dealerLandingPage.landing_page_bottom_text;
            }
            return false;
        },
    },
    methods: {
        toggleShowingFilters() {
            this.$store.commit("UsedSearchOptions/toggleRefineSearchVisible");
            if (this.refineSearchVisible == true) {
                try {
                    bodyScrollLock.disableBodyScroll(this.$refs['filters'].$el);
                } catch (error) {
                    console.error(error);
                    Sentry.captureException(error);
                }
                try {
                    document.querySelector('.site-content').classList.add('site-content--overlap-header');
                } catch (error) {
                    console.error(error);
                    Sentry.captureException(error);
                }
                return;
            }

            try {
                bodyScrollLock.enableBodyScroll(this.$refs['filters'].$el);
            } catch (error) {
                console.error(error);
                Sentry.captureException(error);
            }
            try {
                document.querySelector('.site-content').classList.remove('site-content--overlap-header');
            } catch (error) {
                console.error(error);
                Sentry.captureException(error);
            }
        },

        scrollToResults() {
            this.$store.commit("UsedSearchOptions/closeRefineSearchVisible");
            try {
                bodyScrollLock.enableBodyScroll(this.$refs['filters'].$el);
            } catch (error) {
                console.error(error);
                Sentry.captureException(error);
            }

            try {
                document.querySelector('.site-content').classList.remove('site-content--overlap-header');
            } catch (error) {
                console.error(error);
                Sentry.captureException(error);
            }
            VueScrollTo.scrollTo(this.$refs["results"], 300, {
                offset: -102
            });
        },

        createCarAlert() {
            this.gaTag('Used Vehicles - Results', 'Clicked', 'Stock Alert CTA');
            CreateCarAlert("Search results banner clicked");
        },

        handleMatchHeight: debounce(function () {
            if (window.matchMedia("only screen and (max-width: 767px)").matches) {
                return;
            }
            new MatchHeight(".search-results-vehicle__title-row");
            new MatchHeight(".search-results-vehicle__spec");
            new MatchHeight(".search-results-vehicle__spacer--offer");
            new MatchHeight(".search-results-vehicle__spacer--warranty");
            new MatchHeight(".search-results-vehicle__dealer");
        }, 50),
    },
    created() {
        this.$store.commit("UsedSearchOptions/setResultsLoading", true);
        this.$store.dispatch("UsedSearchOptions/loadQueryParams", this.$route).then(() => {
            this.$store.dispatch("UsedSearchOptions/getResults").then((results) => {});
        });
    },
    watch: {
        $route(to, from) {
            this.$store.dispatch("UsedSearchOptions/loadQueryParams", to).then(() => {
                this.$store.dispatch("UsedSearchOptions/getResults").then((results) => {});
            });
        },
    },
};
</script>

<style lang="scss">
    @import "../../../sass/used/search-results.scss";
</style>


// WEBPACK FOOTER //
// resources/assets/js/used-vue/views/used-results.vue